import { Create, Edit, List, Show, Barcode } from "../Components/index.js";

export default [
    {
        path: "/fd/menu",
        component: List,
        name: "fd-menu-list",
        meta: {
            requiresAuth: true,
        },
    },
];
